/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Unit_Suffix_M2_HourInputs */

const cs_price_unit_suffix_m2_hour = /** @type {(inputs: Price_Unit_Suffix_M2_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/m²/hod.`)
};

const en_price_unit_suffix_m2_hour = /** @type {(inputs: Price_Unit_Suffix_M2_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/m²/h`)
};

/**
* | output |
* | --- |
* | "/m²/h" |
*
* @param {Price_Unit_Suffix_M2_HourInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const price_unit_suffix_m2_hour = /** @type {((inputs?: Price_Unit_Suffix_M2_HourInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Unit_Suffix_M2_HourInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_price_unit_suffix_m2_hour(inputs)
	return cs_price_unit_suffix_m2_hour(inputs)
});